<template>
    <div class="orderconfirm">
        <div class="steps">
            <div class="steps_box">
                <el-steps :active="active" finish-status="success">
                    <el-step title="确认订单信息"></el-step>
                    <el-step title="确认付款"></el-step>
                    <el-step title="完成订购"></el-step>
                </el-steps>
            </div>
            <p class="shop_name">订单提交完成，清尽快付款！</p>
            <p class="pay_tips">请您在7天内完成支付，否则订单回被自动取消！</p>
        </div>
        <div class="price_box">
            <div class="price_tips">应付：<span>{{price}}</span></div>
            <div class="pay_btn">
                <div class="pay" v-for="(item, index) in payTypeList">
                    <img :src="item.icon" class="icon">
                    <span>{{item.name}}</span>
                    <img v-if="item.active" :src="arrow" class="arrow">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getShopmoduleorderinfo, getOrderPayUrl} from '@/api/orderService'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'payType',
    data() {
        return {
            active: 1,
            tableData: [],
            hostname: '',
            price: '',
            orderno: this.$route.query.orderno,
            arrow: require('@/common/images/other/select_icon.png'),
            payTypeList: [
                {
                    name: '在线支付',
                    active: true,
                    icon: require('@/common/images/service/online@2x.png')
                },
                {
                    name: '余额支付',
                    active: false,
                    icon: require('@/common/images/other/icon_money@2x.png')
                }
            ]
        }
    },
    mounted() {
        this.getOrderInfo()
    },
    methods: {
        // 获取订单信息
        getOrderInfo() {
            let data = {
                orderno: this.orderno
            }
            this.setLoading(true)
            getShopmoduleorderinfo({
                data: data,
                success: data => {
                    this.setLoading(false)
                    if (data.data) {
                        let list = []
                        list.push({
                            servicename: data.data.servicename,
                            duration: '12个月',
                            price: data.data.finalpaymoney
                        })
                        this.tableData = list
                        this.hostname = data.data.hostname
                        this.price = data.data.finalpaymoney
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },

        // 去支付
        toPay() {
            let data = {
                orderno: this.orderno
            }
            this.setLoading(true)
            getOrderPayUrl({
                data: data,
                success: data => {
                    this.setLoading(false)
                    if (data.data) {
                       let url = data.data
                       console.log(url)
                       window.location = url
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },

        ...mapActions ([
            'setLoading'
        ])
    }
}
</script>

<style lang="scss">
.orderconfirm {
    background: #fff;
    .steps {
        padding: 40px 30px 20px;
        border-bottom: 1px solid #DCDFE6;
        .steps_box {
            width: 1080px;
            margin: 0 auto;
            .el-steps {
                .el-step {
                    .el-step__head {
                        .el-step__line {
                            top: 22px;
                        }
                        .el-step__icon {
                            width: 40px;
                            height: 40px;
                            .el-step__icon-inner {
                                font-size: 20px;
                                color: #303133;
                            }
                            .el-icon-check {
                                color: #409EFF;
                            }
                        }
                    }
                    .is-success {
                        color: #409EFF;
                        border-color: #409EFF;
                    }
                    .el-step__main {
                        .el-step__title {
                            font-size: 16px;
                            color: #303133;
                            font-weight: 500;
                        }
                        .is-success {
                            color: #409EFF;
                        }
                    }
                }
            }
        }
        .shop_name {
            margin: 60px 0 10px;
            font-size: 16px;
            color: #303133;
        }
        .pay_tips {
            font-size: 14px;
            color: #F56C6C;
        }
    }
    .price_box {
        min-height: 550px;
        padding: 20px 30px;
        .price_tips {
            font-size: 14px;
            color: #303133;
            span {
                font-size: 20px;
                color: #F56C6C;
            }
        }
        .pay_btn {
            display: flex;
            margin-top: 30px;
            div {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 180px;
                height: 50px;
                border-radius: 4px;
                border: 1px solid rgba(220,223,230,1);
                .icon {
                    display: inline-block;
                    width: 16px;
                    height: 16px;
                    margin-right: 10px;
                }
                .arrow {
                    display: inline-block;
                    width: 28px;
                    height: 28px;
                }
            }
            div:first-child {
                margin-right: 40px;
            }
        }
    }
}
</style>